import { fetcher } from 'services/helpers/responseHandler'

const histories = async ({ month, year }) => fetcher.get('pms/histories', { month, year })

const login = async ({
  userName,
  password,
  clientSecret,
  propertyId,
  apiKey,
  accountId,
  pmsChainCode,
  phone
}) =>
  fetcher.post('pms/login', {
    userName,
    password,
    clientSecret,
    apiKey,
    accountId,
    propertyId,
    pmsChainCode,
    phone
  })

const download = async ({ reportId }) => fetcher.get(`pms/histories/${reportId}/download`)

const getPmsEmailSummary = async () => fetcher.get('pms/histories/summary-by-email')

const getHistoriesByEmail = async ({ email }) =>
  fetcher.get('pms/histories', {
    subsidiaryPmsEmail: email,
    retrieveAll: true
  })

const migrateEmail = async ({ email, targetSubsidiaryId }) =>
  fetcher.post('pms/email-migration', { email, targetSubsidiaryId })

const migrateLogs = async ({ histories, targetSubsidiaryId, month, year }) =>
  fetcher.post('pms/histories', {
    histories,
    targetSubsidiaryId,
    month: month,
    year: year,
    kind: 'Migration'
  })

const deleteLogs = async ({ histories, month, year }) =>
  fetcher.post('pms/histories', {
    histories,
    month: month,
    year: year,
    kind: 'Deletion'
  })

const syncStatus = async () => fetcher.get('pms/sync-status')

const healthCheck = async ({ subsidiaryIds }) =>
  fetcher.get('pms/healthcheck', { subsidiaryIds })

const getRoomKeyHotels = async ({ apiKey }) =>
  fetcher.get('pms/roomkey/hotels', { apiKey })

const pmsToggle = async ({ SubsidiaryId, Pms, Status }) =>
  fetcher.post('pms/sync/toggle', { SubsidiaryId, Pms, Status })

const getMarriotGxpConfig = async () => fetcher.get('pms/marriott-config')

const updateMarriotGxpConfig = async data =>
  fetcher.post('pms/marriott-config-update', { ...data })

const getOneTimePassword = async ({ phone }) =>
  fetcher.get('chat/retrieve/last-code', {
    phone,
    otpRequestOn: new Date().toISOString().slice(0, 16)
  })

const checkMarriotEmailConfirmation = async () =>
  fetcher.get('pms/marriott-config-mail-check')

const getOhipConfiguration = async () => fetcher.get('pms/ohip/configure')

const getOhipTenants = async () => fetcher.get('pms/ohip/tenants')

const setOhipConfiguration = async data => fetcher.post('pms/ohip/configure', data)

const tryLoginOhipAuth = async data => fetcher.post('pms/ohip/try-login-auth', data)

const ohipEmailCheck = async () => fetcher.post('pms/ohip/email-check')

const testOhipConnection = async data =>
  fetcher.post('pms/ohip/configure/test-connection', data)

const pmsApi = {
  histories,
  download,
  login,
  syncStatus,
  getRoomKeyHotels,
  healthCheck,
  pmsToggle,
  getMarriotGxpConfig,
  updateMarriotGxpConfig,
  getOneTimePassword,
  checkMarriotEmailConfirmation,
  getOhipConfiguration,
  setOhipConfiguration,
  tryLoginOhipAuth,
  testOhipConnection,
  getOhipTenants,
  ohipEmailCheck,
  getPmsEmailSummary,
  getHistoriesByEmail,
  migrateEmail,
  migrateLogs,
  deleteLogs
}

export default pmsApi
